import React, { useState, useEffect } from 'react';
import { fetchBilanComptable } from '../../../api/bilanComptableApi';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, CircularProgress, Alert, Grid
} from '@mui/material';

const BilanComptable = () => {
  const [bilan, setBilan] = useState({ actif: [], passif: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadBilan = async () => {
      try {
        const data = await fetchBilanComptable(); // Utilisation de la fonction importée
        setBilan(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadBilan();
  }, []);

  const totalActif = bilan.actif.reduce((sum, item) => sum + item.montant, 0);
  const totalPassif = bilan.passif.reduce((sum, item) => sum + item.montant, 0);

  if (loading) return <CircularProgress />;
  if (error) return <Alert severity="error">Erreur : {error}</Alert>;

  return (
    <div className="bilan-comptable">
      <Typography variant="h4" gutterBottom>Bilan Comptable</Typography>
      <Grid container spacing={3}>
        <Grid item xs={6}>
          <Typography variant="h6" gutterBottom>Actif</Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Poste</TableCell>
                  <TableCell>Montant (€)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bilan.actif.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.poste}</TableCell>
                    <TableCell>{item.montant.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell><strong>Total Actif</strong></TableCell>
                  <TableCell><strong>{totalActif.toFixed(2)}</strong></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="h6" gutterBottom>Passif</Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Poste</TableCell>
                  <TableCell>Montant (€)</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {bilan.passif.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell>{item.poste}</TableCell>
                    <TableCell>{item.montant.toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell><strong>Total Passif</strong></TableCell>
                  <TableCell><strong>{totalPassif.toFixed(2)}</strong></TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
      <Typography variant="h6" gutterBottom style={{ marginTop: '20px' }}>
        Résultat Net : {(totalActif - totalPassif).toFixed(2)} €
      </Typography>
    </div>
  );
};

export default BilanComptable;
